import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vuetify/dist/vuetify.min.css';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import Vuetify from 'vuetify';
import VueQRCodeComponent from 'vue-qr-generator';
import '~/plugins';
import '~/components';
import Vuelidate from 'vuelidate';
import Vue2Editor from 'vue2-editor';
import VueSidebarMenu from 'vue-sidebar-menu';
import Echo from 'laravel-echo';
import vuetify from './plugins/vuetify';
import i18n from '~/plugins/i18n';
import store from '~/store';
import App from '~/components/App';
import router from '~/router';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import RolesPermissions from './mixin/RolesPermissions';

require('dotenv').config();

Vue.use(Chartkick.use(Chart));
Vue.use(VueSidebarMenu);
Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Vuetify);
Vue.component('qr-code', VueQRCodeComponent);
Vue.mixin(RolesPermissions);
Vue.use(VueGoodTablePlugin);
Vue.use(Vue2Editor);

Vue.component('fa', FontAwesomeIcon);

window.io = require('socket.io-client');

window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: `${process.env.VUE_APP_DASHBOARD_HOST}:6001`,
    withCredentials: true,
});

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  vuetify,
  ...App,
}).$mount('#app');
